import type { FunctionReturnType } from 'convex/server';
import { api } from 'convex/_generated/api';
import type { Id } from 'convex/_generated/dataModel';

export type Garden = FunctionReturnType<typeof api.gardens.queries.getUserGardens>[number];

export function findGardenById(gardens: Garden[], gardenId: Id<'gardens'> | null): Garden | null {
  if (!gardenId) return null;
  return gardens.find((g) => g._id === gardenId) ?? null;
}

export function getGardenName(
  gardens: Garden[],
  gardenId: Id<'gardens'> | null
): string | undefined {
  return findGardenById(gardens, gardenId)?.name;
}

export function canDeleteGarden(gardens: Garden[]): boolean {
  return gardens.length > 1;
}
